import api from "./api";

const MasterLocationService = {
  // ✅ GET all countries
  getAllCountries: async () => {
    try {
      const response = await api.get("/masterLocation/countries");
      return response.data.data; // returns array of countries
    } catch (error) {
      console.error("Error fetching countries:", error);
      return [];
    }
  },

  // ✅ GET states by countryId
  getStatesByCountry: async (countryId) => {
    try {
      const response = await api.get(`/masterLocation/states/${countryId}`);
      return response.data.data; // returns array of states
    } catch (error) {
      console.error("Error fetching states:", error);
      return [];
    }
  },

  // ✅ GET cities by stateId
  getCitiesByState: async (stateId) => {
    try {
      const response = await api.get(`/masterLocation/cities/${stateId}`);
      return response.data.data; // returns array of cities
    } catch (error) {
      console.error("Error fetching cities:", error);
      return [];
    }
  },
};

export default MasterLocationService;
